"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicResponseMediaStreamsSchema = void 0;
var _zod = require("zod");
var _OlapicResponseStreamItem = require("./OlapicResponseStreamItem");
const olapicResponseMediaStreamsSchema = exports.olapicResponseMediaStreamsSchema = _zod.z.object({
  data: _zod.z.object({
    _embedded: _zod.z.object({
      stream: _zod.z.array(_OlapicResponseStreamItem.olapicStreamItemSchema)
    })
  })
});
